import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { Bank, CaretRight } from '@phosphor-icons/react'
import { springTransition } from '@/themes/animations'

interface MissingIbanAlertProps {
  isVisible: boolean
}

export function MissingIbanAlert({ isVisible }: MissingIbanAlertProps) {
  const navigate = useNavigate()

  return (
    <AnimatePresence mode="popLayout">
      {isVisible && (
        <motion.div
          initial={{ height: 0, opacity: 0, scale: 0.95 }}
          animate={{ height: 'auto', opacity: 1, scale: 1 }}
          exit={{ height: 0, opacity: 0, scale: 0.95, margin: 0, padding: 0 }}
          transition={{ ...springTransition, duration: 0.4 }}
          className="overflow-hidden will-change-[height,opacity,transform]"
        >
          <div
            className="bg-amber-500/10 border border-amber-500/20 rounded-[20px] p-4 flex items-center justify-between cursor-pointer hover:bg-amber-500/15 active:scale-95 transition-all mt-2"
            onClick={() => navigate('/profile?section=info')}
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center shrink-0">
                <Bank size={20} weight="fill" className="text-amber-600" />
              </div>
              <div>
                <h3 className="text-[14px] font-bold text-amber-700 leading-tight block">
                  Banka Hesabınız Eksik
                </h3>
                <p className="text-[12px] font-medium text-amber-600/80 mt-0.5 leading-tight block">
                  Ödemelerinizi alabilmeniz için lütfen hesabınızı ekleyin.
                </p>
              </div>
            </div>
            <CaretRight size={16} weight="bold" className="text-amber-500 shrink-0" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
